<template>
  <v-alert
    :color="color"
    :dense="dense"
    :width="width"
    :max-width="maxWidth"
    :rounded="rounded"
    :icon="icon"
    :prominent="prominent"
    :prominentColor="prominentColor"
    :prominentIconColor="prominentIconColor"
    :prominentIconSize="prominentIconSize"
    :alertBorder="alertBorder"
    :style="alertBorder ? 'overflow: hidden' : ''"
  >
    <div
      v-if="alertBorder"
      :class="alertBorder ? `alert-border ${getBorderPosition}` : ''"
      :style="`background-color: ${alertBorderColor}`"
    ></div>

    <template v-if="icon?.length" v-slot:prepend>
      <v-icon
        v-if="!prominent"
        :size="iconSize"
        :color="iconColor"
        :class="`align-self-${iconAlign}`"
        class="mr-4"
        >{{ icon }}</v-icon
      >
      <template v-else>
        <div
          class="alert-prominent mr-4"
          :style="`background-color: ${prominentColor}`"
        >
          <v-icon :color="prominentIconColor" :size="prominentIconSize">{{
            icon
          }}</v-icon>
        </div>
      </template>
    </template>

    <p class="ma-0" :class="alertTextClass">
      <span v-if="alertLabel.length" class="font-weight-bold"
        >{{ alertLabel }}&nbsp;</span
      >
      {{ alertText }}
    </p>

    <slot />
  </v-alert>
</template>

<script>
export default {
  name: "BaseAlert",
  props: {
    color: {
      type: String,
      default: "",
    },
    dense: {
      type: Boolean,
      default: true,
    },
    width: {
      type: String,
      default: "",
    },
    maxWidth: {
      type: String,
      default: "",
    },
    rounded: {
      type: String,
      default: "md",
    },
    alertLabel: {
      type: String,
      default: "",
    },
    alertText: {
      type: String,
      default: "",
    },
    alertTextClass: {
      type: String,
      default: "",
    },
    icon: {
      type: [String, Boolean],
      default: null,
    },
    iconSize: {
      type: String,
      default: "",
    },
    iconColor: {
      type: String,
      default: "",
    },
    iconAlign: {
      type: String,
      default: "center",
    },
    prominent: {
      type: Boolean,
      default: false,
    },
    prominentColor: {
      type: String,
      default: "",
    },
    prominentIconColor: {
      type: String,
      default: "",
    },
    prominentIconSize: {
      type: String,
      default: "",
    },
    alertBorder: {
      type: Boolean,
      default: false,
    },
    alertBorderPosition: {
      type: String,
      default: "",
    },
    alertBorderColor: {
      type: String,
      default: "",
    },
  },
  computed: {
    getBorderPosition() {
      if (this.alertBorderPosition === "top") {
        return "alert-border-top";
      }
      if (this.alertBorderPosition === "right") {
        return "alert-border-right";
      }
      if (this.alertBorderPosition === "bottom") {
        return "alert-border-bottom";
      }
      if (this.alertBorderPosition === "left") {
        return "alert-border-left";
      }
      return "";
    },
  },
};
</script>

<style lang="scss" scoped>
.alert-prominent {
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  padding: 8px;
}

.alert-border {
  position: absolute;

  &.alert-border-top {
    top: 0;
    left: 0;
    width: 100%;
    height: 6px;
  }

  &.alert-border-right {
    top: 0;
    right: 0;
    width: 6px;
    height: 100%;
  }

  &.alert-border-bottom {
    bottom: 0;
    left: 0;
    width: 100%;
    height: 6px;
  }

  &.alert-border-left {
    top: 0;
    left: 0;
    width: 6px;
    height: 100%;
  }
}
</style>
